var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansCtManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    enableBackground: "new 0 0 88 88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000060008170033836608950000016142226722654950026_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.18,
    strokeMiterlimit: 10,
    d: "M52.9,23.1c-0.1,0.2-0.2,0.4-0.3,0.6 c-2.8,2.8-5.6,5.6-8.4,8.4c-0.5,0.5-1.2,0.4-1.7,0c0,0-0.1-0.1-0.1-0.1c-0.5-0.4-0.6-1.1-0.2-1.7c0,0,0.1-0.1,0.1-0.1l8.4-8.4 c0.3-0.3,0.8-0.4,1.2-0.2C52.5,21.8,52.9,22.4,52.9,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.18,
    strokeMiterlimit: 10,
    d: "M23.2,53c-0.7-0.1-1.3-0.5-1.5-1.2 c-0.2-0.5,0-1.1,0.4-1.4c2.7-2.7,5.4-5.4,8.1-8.1c0.5-0.5,1.3-0.5,1.8,0.1c0,0,0,0,0,0c0.5,0.4,0.7,1.2,0.3,1.7 c0,0.1-0.1,0.1-0.1,0.1c-2.8,2.7-5.5,5.6-8.3,8.3C23.6,52.8,23.4,52.9,23.2,53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.18,
    strokeMiterlimit: 10,
    d: "M21.4,23.1c0.1-0.6,0.5-1.2,1.1-1.5 c0.5-0.3,1.1-0.1,1.4,0.3L32,30c0.5,0.5,0.6,1,0.3,1.5c-0.3,0.6-1,1-1.6,0.9c-0.2-0.1-0.4-0.2-0.5-0.3c-2.8-2.8-5.6-5.5-8.3-8.3 C21.7,23.6,21.5,23.4,21.4,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.18,
    strokeMiterlimit: 10,
    d: "M22.7,38.6h-5.8c-0.7,0-1.2-0.4-1.3-1.1 c0-0.1,0-0.2,0-0.2c-0.1-0.6,0.4-1.2,1-1.3c0.1,0,0.1,0,0.2,0c3.9,0,7.8,0,11.7,0c0.6,0,1.2,0.5,1.2,1.1c0,0.1,0,0.1,0,0.2 c0.1,0.6-0.4,1.2-1,1.3c-0.1,0-0.2,0-0.2,0H22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.18,
    strokeMiterlimit: 10,
    d: "M38.4,22.8v5.8c0.1,0.6-0.4,1.2-1.1,1.3 c-0.1,0-0.2,0-0.3,0c-0.6,0.1-1.2-0.4-1.3-1c0-0.1,0-0.2,0-0.3V16.9c0-0.6,0.5-1.2,1.1-1.2c0,0,0.1,0,0.1,0c0.7-0.1,1.3,0.4,1.4,1 c0,0.1,0,0.1,0,0.2V22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    d: "M36.8,35.3c0.3,0,0.6,0.1,0.9,0.2l33,11.8 c0.6,0.2,1.1,0.6,1.4,1.2c0.5,0.7,0.3,1.7-0.4,2.1c-0.1,0.1-0.2,0.1-0.4,0.2L61.9,55c-1.4,0.6-2.7,1.2-4.1,1.8 c-0.4,0.2-0.8,0.5-1,1c-1.9,4.4-3.9,8.8-5.8,13.2c-0.3,0.7-0.6,1.3-1.5,1.3c-0.9,0-1.7-0.6-2-1.5c-0.5-1.4-1-2.8-1.5-4.2 c-3.5-9.7-7-19.4-10.5-29.1c-0.1-0.4-0.2-0.7-0.1-1.1C35.5,35.8,36.1,35.3,36.8,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D8C957",
    strokeWidth: 0.36,
    strokeMiterlimit: 10,
    d: "M38.8,37.5c0.3,0.1,0.5,0.1,0.8,0.2l29.1,10.4 c0.5,0.2,1,0.5,1.3,1c0.4,0.6,0.3,1.4-0.3,1.9c-0.1,0.1-0.2,0.1-0.4,0.2l-8.3,3.7c-1.2,0.5-2.4,1.1-3.6,1.6 c-0.4,0.2-0.7,0.5-0.9,0.9c-1.7,3.9-3.4,7.8-5.1,11.6c-0.3,0.6-0.6,1.2-1.4,1.2c-0.8,0-1.5-0.5-1.8-1.3c-0.5-1.2-0.9-2.5-1.3-3.7 c-3.1-8.5-6.1-17.1-9.2-25.6c-0.1-0.3-0.2-0.6-0.1-1C37.6,37.9,38.2,37.5,38.8,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#B9AD4E",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    d: "M40.9,39.8c0.2,0.1,0.4,0.1,0.7,0.2l25.1,9 c0.5,0.2,0.8,0.5,1.1,0.9c0.4,0.5,0.2,1.3-0.3,1.6c-0.1,0.1-0.2,0.1-0.3,0.2L60,54.8l-3.1,1.4c-0.3,0.1-0.6,0.4-0.8,0.8l-4.4,10 c-0.2,0.5-0.5,1-1.2,1c-0.7,0-1.3-0.5-1.5-1.1c-0.4-1.1-0.8-2.1-1.2-3.2c-2.6-7.4-5.3-14.8-7.9-22.2c-0.1-0.3-0.1-0.6-0.1-0.8 C39.9,40.1,40.3,39.7,40.9,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#9A9146",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    d: "M42.9,42c0.2,0,0.4,0.1,0.6,0.1 c7.1,2.5,14.1,5.1,21.2,7.6c0.4,0.1,0.7,0.4,1,0.7c0.3,0.4,0.2,1-0.2,1.3c-0.1,0.1-0.2,0.1-0.3,0.2L59,54.7l-2.6,1.2 c-0.3,0.1-0.5,0.4-0.6,0.6c-1.2,2.9-2.5,5.6-3.7,8.5c-0.2,0.5-0.4,0.9-1,0.9c-0.6,0-1.1-0.4-1.3-1c-0.3-0.9-0.6-1.8-1-2.7 l-6.7-18.7c-0.1-0.2-0.1-0.5-0.1-0.7C42.1,42.3,42.5,42,42.9,42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7A743E",
    strokeWidth: 0.37,
    strokeMiterlimit: 10,
    d: "M45,44.2c0.2,0,0.3,0.1,0.4,0.1l17.2,6.2 c0.3,0.1,0.6,0.3,0.7,0.6c0.3,0.4,0.2,0.9-0.2,1.1c-0.1,0-0.1,0.1-0.2,0.1l-4.9,2.2l-2.1,1c-0.2,0.1-0.4,0.3-0.5,0.5 c-1,2.3-2,4.6-3,6.9c-0.2,0.4-0.3,0.7-0.8,0.7c-0.5,0-0.9-0.3-1-0.8l-0.8-2.2l-5.4-15.2c-0.1-0.2-0.1-0.4-0.1-0.6 C44.3,44.4,44.6,44.2,45,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5B5836",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    d: "M47,46.4c0.1,0,0.2,0,0.4,0.1l13.3,4.8 c0.2,0.1,0.5,0.2,0.6,0.5c0.2,0.3,0.2,0.7-0.1,0.9c-0.1,0-0.1,0.1-0.2,0.1l-3.8,1.7l-1.6,0.7c-0.2,0.1-0.3,0.2-0.4,0.4l-2.3,5.3 c-0.1,0.3-0.3,0.5-0.6,0.5c-0.4,0-0.7-0.2-0.8-0.6c-0.2-0.6-0.4-1.1-0.6-1.7c-1.4-3.9-2.8-7.8-4.2-11.7c-0.1-0.1-0.1-0.3-0.1-0.4 C46.5,46.6,46.7,46.4,47,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3C3C2D",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    d: "M49,48.6c0.1,0,0.2,0,0.2,0.1l9.3,3.3 c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.2,0.1,0.5-0.1,0.6c0,0-0.1,0-0.1,0l-2.6,1.2L55,54.7c-0.1,0.1-0.2,0.2-0.3,0.3L53,58.7 c-0.1,0.2-0.2,0.4-0.4,0.4c-0.3,0-0.5-0.2-0.6-0.4c-0.2-0.4-0.3-0.8-0.4-1.2c-1-2.7-2-5.5-2.9-8.2c0-0.1,0-0.2,0-0.3 C48.7,48.8,48.9,48.7,49,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    d: "M51.1,50.8h0.1l5.3,1.9c0.1,0,0.2,0.1,0.2,0.2 c0.1,0.1,0,0.3-0.1,0.4c0,0,0,0,0,0L55.2,54l-0.7,0.3c-0.1,0-0.1,0.1-0.2,0.2c-0.3,0.7-0.6,1.4-1,2.1c0,0.1-0.1,0.2-0.2,0.2 c-0.1,0-0.3-0.1-0.3-0.2c-0.1-0.2-0.2-0.5-0.2-0.7l-1.7-4.8c0-0.1,0-0.1,0-0.2C50.9,50.9,51,50.8,51.1,50.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansCtManagement);
export default __webpack_public_path__ + "static/media/physiciansCTManagement.9bbe8e607c94eee9d406f8206b95ff0d.svg";
export { ForwardRef as ReactComponent };